export enum ActionCardType {
  CompleteFinancialPlan = 'CompleteFinancialPlan',
  CreateInitiative = 'CreateInitiative',
  ClonePreviousYear = 'ClonePreviousYear',
  OpenInitiativesPlan = 'OpenInitiativesPlan',
}

export interface IAction {
  icon: string
  titleKey: string
  descriptionKey: string
  isHighlighted?: boolean
  action: ActionCardType
}
